import { useState } from "react";
import "./Topbar.css";
import ProfilDialog from "../ProfilDialog/ProfilDialog";
import type { User as BackendUser } from "../../types/user";
import { useSidebarToggle } from "../../contexts/SidebarContext";

type TopbarProps = {
  title: string;
  userName: string;
  onLogout?: () => void;
  onMenuClick?: () => void;
  user?: BackendUser;
  sites?: Array<{ id: number; name: string }>;
};

const Topbar = ({ title, userName, onMenuClick, user, sites }: TopbarProps) => {
  const sidebarToggle = useSidebarToggle();
  const handleMenuClick = onMenuClick || sidebarToggle;
  const [isProfilOpen, setIsProfilOpen] = useState(false);

  return (
    <header className="topbar">
      <div className="topbar-left">
        {handleMenuClick && (
          <button
            className="menu-button mobile-only"
            onClick={handleMenuClick}
            aria-label="Toggle menu"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        )}
        <h1 className="topbar-title">{title}</h1>
      </div>

      <div className="topbar-right">
        <div className="topbar-actions">
          <div
            className="user-badge"
            onClick={() => user && setIsProfilOpen(true)}
            style={{ cursor: user ? "pointer" : "default" }}
            title="Voir le profil"
          >
            <span className="user-avatar">👤</span>
            <span className="user-name">{userName}</span>
          </div>
        </div>
      </div>

      {user && (
        <ProfilDialog
          user={user}
          isOpen={isProfilOpen}
          onClose={() => setIsProfilOpen(false)}
          sites={sites}
        />
      )}
    </header>
  );
};

export default Topbar;
